module.exports = __webpack_public_path__ + "img/successIcon.90d3233b.png";